<template>
  <modal
    size="xl"
    :show.sync="isActiveLocal"
    header-classes="bg-primary p-3"
    @close="handleClose"
  >
    <h6 slot="header" class="modal-title text-white font-semibold pt-1">
      EDIT USER
    </h6>
    <div class="">
      <div class="relative bg-white">
        <div class="absolute top-32 right-0 md:block lg:block hidden">
          <!--    <img
          src="./../../assets/images/bg-des/career-dots.svg"
          alt="Dots"
          class=""
        /> -->
        </div>
        <div class="absolute bottom-32 left-0 md:block lg:block hidden">
          <!--  <img
          src="./../../assets/images/bg-des/CD-dots2.svg"
          alt="Dots"
          class=""
        /> -->
        </div>
        <div class="absolute top-1/4 right-1/4 md:block lg:block hidden">
          <!--    <img src="./../../assets/images/bg-des/elli.svg" alt="Dots" class="" /> -->
        </div>
        <div class="absolute top-1/2 left-20 md:block lg:block hidden">
          <!--    <img src="./../../assets/images/bg-des/elli.svg" alt="Dots" class="" /> -->
        </div>
        <div class="w-full px-6">
          <!--     <div class="mt-10">
          <b-tabs content-class="" justified class="root cust-of">
            <b-tab active class="helo cust-width"
              ><template #title>
                <div class="p-1 my-auto">
                  <p class="pt-1 font-semibold fsize14-12px">Caregiver</p>
                </div>
              </template>
          <div class="md:pt-10 lg:pt-10 pt-8">
                <b-tabs content-class="" justified class="root-il cust-of">
                  <b-tab active class="helo cust-width"
                    ><template #title>
                      <div class="p-1">
                        <p class="pt-1 font-semibold fsize14-12px">Free</p>
                      </div>
                    </template>
                    <div class="md:pt-10 lg:pt-10 pt-6">
                      <p class="mc-subtitle">
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                        Tincidunt nisl vitae vivamus euismod dolor morbi vel
                        lobortis. Neque porttitor massa felis, lacinia. Eget sed
                        semper viverra orci non ut. Massa enim integer nec donec
                        odi.
                      </p>
                      <div class="pt-4 w-full">
                        <div class="flex flex-wrap">
                          <div class="md:w-1/3 lg:w-1/3 w-full pt-4">
                            <p class="input-title-black">Email Address</p>
                            <b-form-input
                              v-model="text"
                              placeholder="Enter your EmailID"
                              class="border-primary mt-1 shadow-md"
                            ></b-form-input>
                          </div>
                          <div
                            class="
                              md:ml-4
                              lg:ml-4
                              ml-0
                              mt-4
                              md:w-1/3
                              lg:w-1/3
                              w-full
                            "
                          >
                            <p class="input-title-black">Phone</p>
                            <b-form-input
                              v-model="text"
                              placeholder="Enter your phone no"
                              class="border-primary shadow-md mt-1"
                            ></b-form-input>
                          </div>
                        </div>
                        <base-button
                          type="primary"
                          class="
                            md:px-10
                            lg:px-10
                            px-6
                            md:py-2
                            lg:py-2
                            py-1
                            border-2
                            text-base
                            font-bold
                            mt-6
                          "
                          >Register</base-button
                        >
                      </div>
                    </div>
                  </b-tab>
                  <b-tab
                    ><template #title>
                      <div class="p-1">
                        <p class="pt-1 font-semibold fsize14-12px">Basic</p>
                      </div>
                    </template>
                  </b-tab>
                  <b-tab
                    ><template #title>
                      <div class="p-1">
                        <p class="pt-1 font-semibold fsize14-12px">Premium</p>
                      </div>
                    </template>
                  </b-tab>
                </b-tabs>
              </div>
            </b-tab>
            <b-tab
              ><template #title>
                <div class="p-1 my-auto">
                  <p class="pt-1 font-semibold fsize14-12px">Well-wisher</p>
                </div>
              </template>
              <div class="md:pt-10 lg:pt-10 pt-8">
                <b-tabs content-class="" justified class="root-il cust-of">
                  <b-tab active class="helo cust-width"
                    ><template #title>
                      <div class="p-1">
                        <p class="pt-1 font-semibold fsize14-12px">Free</p>
                      </div>
                    </template>
                    <div class="md:pt-10 lg:pt-10 pt-6">
                      <p class="mc-subtitle">
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                        Tincidunt nisl vitae vivamus euismod dolor morbi vel
                        lobortis. Neque porttitor massa felis, lacinia. Eget sed
                        semper viverra orci non ut. Massa enim integer nec donec
                        odi.
                      </p>
                      <div class="pt-4 w-full">
                        <div class="flex flex-wrap">
                          <div class="md:w-1/3 lg:w-1/3 w-full pt-4">
                            <p class="input-title-black">Email Address</p>
                            <b-form-input
                              v-model="text"
                              placeholder="Enter your EmailID"
                              class="border-primary shadow-md mt-1"
                            ></b-form-input>
                          </div>
                          <div
                            class="
                              md:pl-4
                              lg:pl-4
                              ml-0
                              pt-4
                              md:w-1/3
                              lg:w-1/3
                              w-full
                            "
                          >
                            <p class="input-title-black">Phone</p>
                            <b-form-input
                              v-model="text"
                              placeholder="Enter your phone no"
                              class="border-primary shadow-md mt-1"
                            ></b-form-input>
                          </div>
                          <div
                            class="
                              md:pl-4
                              lg:pl-4
                              pl-0
                              pt-4
                              md:w-1/3
                              lg:w-1/3
                              w-full
                            "
                          >
                            <p class="input-title-black">
                              Caregiver Email Address
                            </p>
                            <b-form-input
                              v-model="text"
                              placeholder="Enter your Caregiver EmailID"
                              class="border-primary shadow-md mt-1"
                            ></b-form-input>
                          </div>
                        </div>
                        <base-button
                          type="primary"
                          class="
                            md:px-10
                            lg:px-10
                            px-6
                            md:py-2
                            lg:py-2
                            py-1
                            border-2
                            text-base
                            font-bold
                            mt-6
                          "
                          >Register</base-button
                        >
                      </div>
                    </div>
                  </b-tab>
                  <b-tab
                    ><template #title>
                      <div class="p-1">
                        <p class="pt-1 font-semibold fsize14-12px">Premium</p>
                      </div>
                    </template>
                  </b-tab>
                </b-tabs>
              </div>
            </b-tab>
            <b-tab
              ><template #title>
                <div class="p-1 my-auto">
                  <p class="pt-1 font-semibold fsize14-12px">
                    Healthcare Proffesionals
                  </p>
                </div>
              </template>
              <div class="md:pt-10 lg:pt-10 pt-8">
                <b-tabs content-class="" justified class="root-il cust-of">
                  <b-tab active class="helo cust-width"
                    ><template #title>
                      <div class="p-1">
                        <p class="pt-1 font-semibold fsize14-12px">Paid Plan</p>
                      </div>
                    </template>
                    <div class="md:pt-10 lg:pt-10 pt-6">
                      <p class="mc-subtitle">
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                        Tincidunt nisl vitae vivamus euismod dolor morbi vel
                        lobortis. Neque porttitor massa felis, lacinia. Eget sed
                        semper viverra orci non ut. Massa enim integer nec donec
                        odi.
                      </p>
                      <div class="pt-4 w-full">
                        <div class="flex flex-wrap">
                          <div class="md:w-1/3 lg:w-1/3 w-full pt-4">
                            <p class="input-title-black">Email Address</p>
                            <b-form-input
                              v-model="text"
                              placeholder="Enter your EmailID"
                              class="border-primary shadow-md mt-1"
                            ></b-form-input>
                          </div>
                          <div
                            class="
                              md:ml-4
                              lg:ml-4
                              ml-0
                              mt-4
                              md:w-1/3
                              lg:w-1/3
                              w-full
                            "
                          >
                            <p class="input-title-black">Phone No</p>
                            <b-form-input
                              v-model="text"
                              placeholder="Enter your phone no"
                              class="border-primary shadow-md mt-1"
                            ></b-form-input>
                          </div>
                        </div>
                        <base-button
                          type="primary"
                          class="
                            md:px-10
                            lg:px-10
                            px-6
                            md:py-2
                            lg:py-2
                            py-1
                            border-2
                            text-base
                            font-bold
                            mt-6
                          "
                          >Register</base-button
                        >
                      </div>
                    </div>
                  </b-tab>
                </b-tabs>
              </div>
            </b-tab>
          </b-tabs>
        </div> -->
          <div class="">
            <div class="pt-4 w-full">
              <div class="md:flex">
                <div class="md:w-1/2 lg:w-1/2 w-full pt-4">
                  <p class="input-title-black">First Name</p>
                  <b-form-input
                    v-model="userData.firstname"
                    placeholder="Enter First Name"
                    class="border-primary mt-1 shadow-md"
                  ></b-form-input>
                </div>
                <div class="md:pl-4 lg:pl-4 ml-0 mt-4 md:w-1/2 lg:w-1/2 w-full">
                  <p class="input-title-black">Last Name</p>
                  <b-form-input
                    v-model="userData.lastname"
                    placeholder="Enter Last Name"
                    class="border-primary mt-1 shadow-md"
                  ></b-form-input>
                </div>
              </div>
            </div>
          </div>
          <div class="mt-2">
            <div class="pt-4 w-full">
              <div class="md:flex">
                <div class="md:w-1/2 lg:w-1/2 w-full pt-4">
                  <p class="input-title-black">Email Address</p>
                  <b-form-input
                    v-model="userData.email"
                    placeholder="Enter your EmailID"
                    class="border-primary mt-1 shadow-md"
                  ></b-form-input>
                </div>
                <div class="md:pl-4 lg:pl-4 ml-0 mt-4 md:w-1/2 lg:w-1/2 w-full">
                  <p class="input-title-black">Phone No</p>
                  <b-form-input
                    v-model="userData.mobile"
                    placeholder="Enter your phone no "
                    class="border-primary shadow-md mt-1"
                  ></b-form-input>
                </div>
              </div>
            </div>
          </div>
          <div v-for="(item, index) in profileData" :key="index">
            <div class="mt-12">
              <p class="input-title-black font-semibold">Age</p>
              <div class="mt-4 md:flex justify-between">
                <div class="w-1/3">
                  <b-form-radio
                    v-model="item.age"
                    :aria-describedby="areaDescribedby"
                    :name="item.age"
                    value="15-20"
                    ><p>15-20</p></b-form-radio
                  >
                </div>
                <div class="w-1/3">
                  <b-form-radio
                    v-model="item.age"
                    :aria-describedby="areaDescribedby"
                    :name="item.age"
                    value="20-30"
                    ><p>20-30</p></b-form-radio
                  >
                </div>
                <div class="w-1/3">
                  <b-form-radio
                    v-model="item.age"
                    :aria-describedby="areaDescribedby"
                    :name="item.age"
                    value="30-50"
                    ><p>30-50</p></b-form-radio
                  >
                </div>
              </div>
              <div class="md:flex mt-4">
                <div class="w-1/3">
                  <b-form-radio
                    v-model="item.age"
                    :aria-describedby="areaDescribedby"
                    :name="item.age"
                    value="50-70"
                    ><p>50-70</p></b-form-radio
                  >
                </div>
                <div class="w-1/3">
                  <b-form-radio
                    v-model="selected"
                    :aria-describedby="areaDescribedby"
                    :name="item.age"
                    value="More than 70"
                    ><p>More than 70</p></b-form-radio
                  >
                </div>
              </div>
            </div>
            <div class="mt-12">
              <p class="input-title-black font-semibold">Occupation</p>
              <div class="mt-4 md:flex justify-between">
                <div class="w-1/3">
                  <b-form-radio
                    v-model="item.occupation"
                    :aria-describedby="areaDescribedby"
                    :name="item.occupation"
                    value="Main income provider"
                    ><p>Main income provider</p></b-form-radio
                  >
                </div>
                <div class="w-1/3">
                  <b-form-radio
                    v-model="item.occupation"
                    :aria-describedby="areaDescribedby"
                    :name="item.occupation"
                    value="Secondary income provider"
                    ><p>Secondary income provider</p></b-form-radio
                  >
                </div>
                <div class="w-1/3">
                  <b-form-radio
                    v-model="item.occupation"
                    :aria-describedby="areaDescribedby"
                    :name="item.occupation"
                    value="Not working"
                    ><p>Not working</p></b-form-radio
                  >
                </div>
              </div>
            </div>
            <div class="locationcity">
              <div class="pt-4 w-full">
                <div class="md:flex">
                  <div class="md:w-1/2 lg:w-1/2 w-full pt-4">
                    <p class="input-title-black">Location</p>
                    <b-form-input
                      v-model="item.address"
                      placeholder="Enter your location"
                      class="border-primary mt-1 shadow-md"
                    ></b-form-input>
                  </div>
                  <div
                    class="md:pl-4 lg:pl-4 ml-0 mt-4 md:w-1/2 lg:w-1/2 w-full"
                  >
                    <p class="input-title-black">City</p>
                    <b-form-input
                      v-model="item.city"
                      placeholder="Enter your city"
                      class="border-primary mt-1 shadow-md"
                    ></b-form-input>
                  </div>
                </div>
              </div>
            </div>

            <div class="mt-12">
              <p class="input-title-black font-semibold">
                Which of the following do you identify with as being your role?
              </p>
              <div class="mt-4 md:flex justify-between">
                <div class="w-1/3">
                  <b-form-radio
                    v-model="item.roleType"
                    :aria-describedby="areaDescribedby"
                    :name="item.roleType"
                    value="Prime Caregiver"
                    ><p>Primary Caregiver</p></b-form-radio
                  >
                </div>
                <div class="w-1/3">
                  <b-form-radio
                    v-model="item.roleType"
                    :aria-describedby="areaDescribedby"
                    :name="item.roleType"
                    value="Healthcare Proffesional"
                    ><p>Healthcare Proffesional</p></b-form-radio
                  >
                </div>
                <div class="w-1/3">
                  <b-form-radio
                    v-model="item.roleType"
                    :aria-describedby="areaDescribedby"
                    :name="item.roleType"
                    value="Have been a Caregiver"
                    ><p>Have been a Caregiver</p></b-form-radio
                  >
                </div>
              </div>
              <div class="mt-4 md:flex justify-between">
                <div class="w-1/3">
                  <b-form-radio
                    v-model="item.roleType"
                    :aria-describedby="areaDescribedby"
                    :name="item.roleType"
                    value="Will be a Caregiver"
                    ><p>Will be a Caregiver</p></b-form-radio
                  >
                </div>
                <div class="w-1/3">
                  <b-form-radio
                    v-model="item.roleType"
                    :aria-describedby="areaDescribedby"
                    :name="item.roleType"
                    value="Need Caregiving"
                    ><p>Need Caregiving</p></b-form-radio
                  >
                </div>
                <div class="w-1/3">
                  <b-form-radio
                    v-model="item.roleType"
                    :aria-describedby="areaDescribedby"
                    :name="item.roleType"
                    value="Well-wisher of a Caregiver"
                    ><p>Well-wisher of a Caregiver</p></b-form-radio
                  >
                </div>
              </div>
            </div>

            <div class="locationcity">
              <div class="pt-4 w-full">
                <div class="md:flex">
                  <div class="md:w-1/2 lg:w-1/2 w-full pt-4">
                    <p class="input-title-black">
                      How long have you been/were in this role for?
                    </p>
                    <b-form-input
                      v-model="item.experience"
                      placeholder=""
                      class="border-primary mt-1 shadow-md"
                    ></b-form-input>
                  </div>
                </div>
              </div>
            </div>

            <div class="mt-12">
              <p class="input-title-black font-semibold">
                Who do you care for or who did you care for?
              </p>
              <div class="mt-4 md:flex justify-between">
                <div class="w-1/3">
                  <b-form-radio
                    v-model="item.careFor"
                    :aria-describedby="areaDescribedby"
                    :name="item.careFor"
                    value="Spouse/Partner"
                    ><p>Spouse/Partner</p></b-form-radio
                  >
                </div>
                <div class="w-1/3">
                  <b-form-radio
                    v-model="item.careFor"
                    :aria-describedby="areaDescribedby"
                    :name="item.careFor"
                    value="Parents"
                    ><p>Parents</p></b-form-radio
                  >
                </div>
                <div class="w-1/3">
                  <b-form-radio
                    v-model="item.careFor"
                    :aria-describedby="areaDescribedby"
                    :name="item.careFor"
                    value="Speial needs Child"
                    ><p>Special Needs Child</p></b-form-radio
                  >
                </div>
              </div>
              <div class="mt-4 md:flex justify-between">
                <div class="w-1/3">
                  <b-form-radio
                    v-model="item.careFor"
                    :aria-describedby="areaDescribedby"
                    :name="item.careFor"
                    value="Child"
                    ><p>Child</p></b-form-radio
                  >
                </div>
                <div class="w-1/3">
                  <b-form-radio
                    v-model="item.careFor"
                    :aria-describedby="areaDescribedby"
                    :name="item.careFor"
                    value="Sibling"
                    ><p>Sibling</p></b-form-radio
                  >
                </div>
                <div class="w-1/3">
                  <b-form-radio
                    v-model="item.careFor"
                    :aria-describedby="areaDescribedby"
                    :name="item.careFor"
                    value="Friend"
                    ><p>Friend</p></b-form-radio
                  >
                </div>
              </div>
              <div class="mt-4 md:flex justify-between">
                <div class="w-1/3">
                  <b-form-radio
                    v-model="item.careFor"
                    :aria-describedby="areaDescribedby"
                    :name="item.careFor"
                    value="Grandparent"
                    ><p>Grandparent</p></b-form-radio
                  >
                </div>
              </div>
            </div>

            <div class="locationcity">
              <div class="pt-4 w-full">
                <div class="md:flex">
                  <div class="md:w-1/2 lg:w-1/2 w-full pt-4">
                    <p class="input-title-black">
                      What are the significant illness that you care receiver is
                      suffering from?
                    </p>
                    <b-form-input
                      v-model="item.illness"
                      placeholder=""
                      class="border-primary mt-1 shadow-md"
                    ></b-form-input>
                  </div>
                </div>
              </div>
            </div>

            <div class="mt-12">
              <p class="input-title-black font-semibold">
                Which of the following areas do you need the most support?
              </p>
              <div class="aligncheck">
                <b-form-group>
                  <b-form-checkbox-group
                    id="checkbox-group-2"
                    v-model="item.areas"
                    aria-describedby="ariaDescribedby"
                    :name="item.areas"
                  >
                    <div class="mt-4 md:flex justify-between items-center">
                      <div class="w-1/3">
                        <b-form-checkbox value="Social">Social</b-form-checkbox>
                      </div>
                      <div class="w-1/3">
                        <b-form-checkbox value="Psychological"
                          >Psychological</b-form-checkbox
                        >
                      </div>
                      <div class="w-1/3">
                        <b-form-checkbox value="Physical"
                          >Physical</b-form-checkbox
                        >
                      </div>
                    </div>
                    <div class="mt-4 md:flex justify-between items-center">
                      <div class="w-1/3">
                        <b-form-checkbox value="Financial / Legal"
                          >Financial / Legal</b-form-checkbox
                        >
                      </div>
                      <div class="w-1/3">
                        <b-form-checkbox value="Spiritual"
                          >Spiritual</b-form-checkbox
                        >
                      </div>
                      <div class="w-1/3">
                        <b-form-checkbox value="Life / Work Purpose"
                          >Life / Work Purpose</b-form-checkbox
                        >
                      </div>
                    </div>
                  </b-form-checkbox-group>
                </b-form-group>
              </div>
            </div>

            <div class="mt-12">
              <p class="input-title-black font-semibold">
                How would you want to receiver information on caregiver support?
              </p>
              <div class="aligncheck">
                <b-form-group>
                  <b-form-checkbox-group
                    id="checkbox-group-1"
                    v-model="item.supportType"
                    aria-describedby="ariaDescribedby"
                    :name="item.supportType"
                  >
                    <div class="mt-4 md:flex justify-between items-center">
                      <div class="w-1/3">
                        <b-form-checkbox value="One on One"
                          >One on One</b-form-checkbox
                        >
                      </div>
                      <div class="w-1/3">
                        <b-form-checkbox value="Email">Email</b-form-checkbox>
                      </div>
                      <div class="w-1/3">
                        <b-form-checkbox value="Whatsapp"
                          >Whatsapp</b-form-checkbox
                        >
                      </div>
                    </div>
                  </b-form-checkbox-group>
                </b-form-group>
              </div>
            </div>

            <!-- <div class="py-8">
          <p class="text-base font-bold clr4F0A4B">Or register with</p>
          <div class="flex pt-2">
            <img
              src="./../../../assets/images/logo/reg-google.svg"
              alt="google"
              class="mr-4"
            />
            <img
              src="./../../../assets/images/logo/reg-fb.svg"
              alt="google"
              class="ml-4"
            />
          </div>
        </div> -->
          </div>
        </div>
      </div>
    </div>
    <template slot="footer">
      <base-button type="primary" @click="editUser">SAVE CHANGES</base-button>
      <base-button type="secondary" class="ml-auto" @click="handleClose"
        >CLOSE</base-button
      >
    </template>
  </modal>
</template>
<script>
import { mapState } from "vuex";
export default {
  props: {
    isActive: {
      type: Boolean,
    },
    userData: Object,
  },
  computed: {
    isActiveLocal: {
      get() {
        return this.isActive;
      },
      set(val) {
        this.handleClose();
      },
    },
    ...mapState("eLearning", ["profileData"]),
  },
  data() {
    return {
      visible: true,
      selected: "",
      areaDescribedby: "",
    };
  },
  methods: {
    handleClose() {
      this.$emit("close");
    },
    editUser() {
      let payload = {
        _id: this.userData.id,
        firstname: this.userData.firstname,
        lastname: this.userData.lastname,
        mobile: this.userData.mobile,
        email: this.userData.email,
      };
      this.profileData.forEach((x) => {
        if (x.age) {
          Object.assign(payload, { age: x.age });
        }
        if (x.occupation) {
          Object.assign(payload, { occupation: x.occupation });
        }
        if (x.address) {
          Object.assign(payload, { address: x.address });
        }
        if (x.city) {
          Object.assign(payload, { city: x.city });
        }
        if (x.roleType) {
          Object.assign(payload, { roleType: x.roleType });
        }
        if (x.careFor) {
          Object.assign(payload, { careFor: x.careFor });
        }
        if (x.experience) {
          Object.assign(payload, { experience: x.experience });
        }
        if (x.illness) {
          Object.assign(payload, { illness: x.illness });
        }
        if (x.areas) {
          Object.assign(payload, { areas: x.areas });
        }
        if (x.supportType) {
          Object.assign(payload, { supportType: x.supportType });
        }
      });

      return new Promise(async (resolve, reject) => {
        try {
          let loader = this.$loading();
          const data = await this.$store.dispatch(
            "eLearning/editUser",
            payload
          );
          if (data.code == 200) {
            this.$swal.fire({
              title: "Edited",

              text: "Edited Successfully",

              icon: "success",

              showCancelButton: false,
            });
            loader.close();
            this.handleClose();
          }
          resolve(data);
          loader.close();
        } catch (err) {
          reject(err);
          loader.close();
        }
      });
    },
  },
};
</script>
<style lang="scss">
.p-0card > .card-body {
  padding: 0px !important;
}

.root > div > .nav-tabs .nav-link.active,
.nav-tabs .nav-item.show .nav-link {
  /* background: red; */
  /* border-top-width: 10px; */
  border-bottom: 4px solid #830c81;
  background-color: rgb(255, 255, 255);
  border-top: none;
  border-left: none;
  border-right: none;
  font-weight: 700;
  color: #333;
  display: flex;
  justify-content: center;
  /* background-color: antiquewhite; */
}
.root > div > .nav-tabs .nav-link {
  /* border: none !important; */
  border-radius: 0% !important;
}
.root > div > .nav-tabs .nav-item {
  flex-grow: 0 !important;
}
.root > div > .nav-tabs .nav-link:hover {
  /* border: none !important; */
  border-top: none;
  border-left: none;
  border-right: none;
  /* border-bottom: 4px solid #830c81; */
}
.root > div > .nav {
  flex-wrap: nowrap !important;
  overflow-y: hidden;
}
.root > div > .nav-tabs .nav-link {
  width: 220px;
  display: flex;
  justify-content: center;
  @media (max-width: 640px) {
    width: auto;
    height: 60px;
  }
}
.root-il > div > .nav-tabs .nav-link {
  width: 120px;
  justify-content: center;
  @media (max-width: 640px) {
    width: auto;
  }
}
/* Oveerflow */
.cust-of > div > .nav {
  overflow-x: auto !important;
}
.cust-of > div > .nav::-webkit-scrollbar {
  width: 8px !important;
  height: 12px !important;
}
.cust-of > div > .nav::-webkit-scrollbar-thumb:hover {
  background: #d6d6d6 !important;
}

.cust-of > div > .nav::-webkit-scrollbar-thumb {
  background: #d6d6d6 !important;
  border-radius: 6px !important;
}
.cust-of > div > .nav::-webkit-scrollbar-track {
  box-shadow: inset 0 0 3px #80808026 !important;
  border-radius: 6px !important;
}
.scope-padding > .card-body {
  padding-left: 0%;
  padding-right: 0%;
  padding-top: 0%;
  padding-bottom: 0%;
}

.root-il > div > .nav-tabs .nav-link.active,
.nav-tabs .nav-item.show .nav-link {
  /* background: red; */
  /* border-top-width: 10px; */
  border-bottom: 4px solid #830c81;
  background-color: rgb(255, 255, 255);
  border-top: none;
  border-left: none;
  border-right: none;
  font-weight: 700;
  color: #333;
  display: flex;
  justify-content: center;
  /* background-color: antiquewhite; */
}
.root-il > div > .nav-tabs .nav-link {
  /* border: none !important; */
  border-radius: 0% !important;
}
.root-il > div > .nav-tabs .nav-item {
  flex-grow: 0 !important;
}
.root-il > div > .nav-tabs .nav-link:hover {
  /* border: none !important; */
  border-top: none;
  border-left: none;
  border-right: none;
  /* border-bottom: 4px solid #830c81; */
}
.root-il > div > .nav {
  flex-wrap: nowrap !important;
  overflow-y: hidden;
}
</style>
